<template>
  <div>
    <div class="container">
      <h1 class="text-center home-row-spacing"><strong>Welcome to the Portal</strong></h1>
      <div class="row">
        <div class="col text-center">Tools and utilities for Helium app developers</div>
      </div>
      <div class="row text-center home-row-spacing">
        <div class="col-4 mx-auto">
          <div class="mb-2 showHand" @click="pushApps">
            <h4 class="text-primary"><i class="fas fa-mobile-alt"></i> Helium Apps</h4>
            <p>Inspect, monitor and configure your apps</p>
          </div>
        </div>
        <div class="col-4 mx-auto" @click="pushHeliumJourney">
          <div class="mb-2 showHand">
            <h4 class="text-primary"><i class="fas fa-rocket"></i> HeliumJourney Sync</h4>
            <p>Integrate Helium and Journey</p>
          </div>
        </div>
        <div class="col-4 mx-auto" @click="pushDeployments()">
          <div v-bind:class="[$parent.isProduction ? 'showHand' : 'disabledBlock', 'mb-2']">
            <h4 v-bind:class="[$parent.isProduction ? 'text-primary' : 'disabled']">
              <i class="fas fa-cloud-upload-alt"></i> DevOps Deployments
            </h4>
            <p v-bind:class="[$parent.isProduction ? '' : 'disabled']">Schedule a facilitated deployment</p>
          </div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
      }
    },
    methods: {
      pushApps: function () {
        this.$router.push({name: 'Apps'})
      },
      pushHeliumJourney: function () {
        this.$router.push({name: 'Sync'})
      },
      pushDeployments: function () {
        if (this.$parent.isProduction) {
          this.$router.push({name: 'Deployments'})
        }
      }
    }
  }
</script>

<style scoped>

a, a:hover {
  color: inherit;
  text-decoration: inherit;
}

.home-row-spacing {
  padding-top: 50px;
}

.showHand {
  cursor: pointer;
  padding: 20px;
  min-height: 135px;
}

.disabledBlock{
  color:grey;
  text-decoration:none;
  cursor:default;
  padding: 20px;
  min-height: 135px;
}

.disabled{
  color:grey;
  text-decoration:none;
  cursor:default;
}

.showHand:hover {
  background-color: #F7F7F7;
  border-radius: 20px;
}

</style>



// WEBPACK FOOTER //
// Home.vue?06bee3d8